import { DictionaryType } from 'types/story';
import { DEFAULT_MEDIA_QUERY_PLATFORMS, COMPONENT_STATES, COMPONENT_TYPE as TYPE } from 'common/constants';
import { UNIFORM_PROPS } from 'common/constants/component-props';
import { getText } from 'common/utils/dictionary';
import { generateElementId, generateNodeId } from 'common/utils/generate-id';
import View from 'client/components/common/BuildingBlocks/Share/Share';
import { SHARE_TYPE } from './constants';

/**
 * @param options {Object=}
 * @param options.dictionary {Object=}
 * @returns {{ view, model }}
 * @constructor
 */
export const SHARE = (options: DictionaryType = {}) => {
	const _id = generateElementId();

	return {
		view: View,
		get model() {
			const type = TYPE.SHARE;

			return {
				_id,
				type,
				uiConfig: {
					layer: undefined,
					editorProps: {
						name: SHARE.displayName,
						selectable: true,
						draggable: true,
						expandable: false,
						expanded: false,
					},
					nodeProps: {
						id: generateNodeId(_id, SHARE.displayName),
					},
					componentProps: {
						[UNIFORM_PROPS.shareType]: SHARE_TYPE.fb,
						[UNIFORM_PROPS.shareCard]: false,
						styles: {
							[COMPONENT_STATES.DEFAULT]: {
								[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {},
							},
							[COMPONENT_STATES.HOVER]: {
								[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
									opacity: 0.7,
								},
							},
						},
						other: {},
					},
				},
				children: {
					[COMPONENT_STATES.DEFAULT]: {
						[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: getText(options.dictionary, type, 'text'),
					},
				},
			};
		},
	};
};

SHARE.displayName = 'Share';
